import {Component, OnInit} from '@angular/core';
import {Helper} from '../../../../helpers/helper.service';
import {ActivatedRoute} from '@angular/router';
import {ServiceSubjectService} from '../../../Services/service-subject.service';
import {ServiceSubject} from '../../../Models/ServiceSubject';
import {environment} from '../../../../../environments/environment';

@Component({
  selector: 'app-view-service-subject',
  templateUrl: './view-service-subject.component.html',
  styleUrls: ['./view-service-subject.component.scss']
})
export class ViewServiceSubjectComponent implements OnInit {
  public subjectId: number;
  public subject: ServiceSubject = new ServiceSubject();
  public baseUrl = environment.apiUrl;

  constructor(
    private route: ActivatedRoute,
    private subjectService: ServiceSubjectService
  ) {

  }

  ngOnInit() {
    this.route.params.subscribe(params => {
      if (Helper.isDefined(params['id'])) {
        this.subjectId = params['id'];
        this.getSubjectItem();
      }
    });
  }

  getSubjectItem() {
    this.subjectService.getServiceSubjectItem(this.subjectId).subscribe((resp: ServiceSubject) => {
      this.subject = resp;
    });
  }

  getFontAwesomeIconFromMIME(mimeType) {
    const icon_classes = {
      // Media
      image: 'fa-file-image-o',
      audio: 'fa-file-audio-o',
      video: 'fa-file-video-o',
      // Documents
      'application/pdf': 'fa-file-pdf-o',
      'application/msword': 'fa-file-word-o',
      'application/vnd.ms-word': 'fa-file-word-o',
      'application/vnd.oasis.opendocument.text': 'fa-file-word-o',
      'application/vnd.openxmlformats-officedocument.wordprocessingml':
        'fa-file-word-o',
      'application/vnd.ms-excel': 'fa-file-excel-o',
      'application/vnd.openxmlformats-officedocument.spreadsheetml':
        'fa-file-excel-o',
      'application/vnd.oasis.opendocument.spreadsheet': 'fa-file-excel-o',
      'application/vnd.ms-powerpoint': 'fa-file-powerpoint-o',
      'application/vnd.openxmlformats-officedocument.presentationml':
        'fa-file-powerpoint-o',
      'application/vnd.oasis.opendocument.presentation': 'fa-file-powerpoint-o',
      'text/plain': 'fa-file-text-o',
      'text/html': 'fa-file-code-o',
      'application/json': 'fa-file-code-o',
      // Archives
      'application/gzip': 'fa-file-archive-o',
      'application/zip': 'fa-file-archive-o'
    };

    for (const key in icon_classes) {
      if (icon_classes.hasOwnProperty(key)) {
        if (mimeType.search(key) === 0) {
          return icon_classes[key];
        }
      } else {
        return 'fa-file-o';
      }
    }
  }
}
